export default __webpack_public_path__ + "static/media/Class_3_Sample_QP.5f464c2f.jpg";